import { FraudDecision } from '@/types/Activity'

export const FRAUD_DECISION_LABELS: Record<FraudDecision, string> = {
  [FraudDecision.confirmedFraud]: 'Confirmed Fraud',
  [FraudDecision.suspectedFraud]: 'Suspected Fraud',
  [FraudDecision.internalRiskHighRisk]: 'Internal risk database - high risk',
  [FraudDecision.internalRiskClaimHighRisk]: 'Internal risk database - claim high risk',
  [FraudDecision.internalRiskMediumRisk]: 'Internal risk database - medium risk',
}
